import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class singleServiceActionsMenuCtrl implements IController {

  onOpen: Function;
  serviceStatus: any;
  service: any;
  onSendServiceTextMessage: Function;
  onCreateDelivery: Function;
  onDeclineService: Function;
  onEditService: Function;

  private disableButtons: any;
  private inactiveMenu: any;
  private inactiveCreate: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.disableButtons = {
      editService: false,
      sendSms: false,
      decline: false,
      createDeliveries: false
    }
  };

  $onChanges(changes) {
    if (changes.serviceStatus) {
      this.inactiveMenu = _.isEqual(changes.serviceStatus.currentValue, 'InActive');
      this.inactiveCreate = _.isEqual(changes.serviceStatus.currentValue, 'idle');
    }
  };

  ////////////////////////////////////////////////////////////////

  // ******************************
  //        External methods
  // ******************************

  openActionsMenu($mdMenu, ev) {
    this.onOpen(this.service, (disableButtons) => {
      this.disableButtons = {
        editService: disableButtons.editService,
        sendSms: disableButtons.sendSms,
        decline: disableButtons.decline,
        createDeliveries: disableButtons.createDeliveries
      };
      $mdMenu.open(ev);
    })
  }
}


angular
  .module('bringoz.admin.coordinations')
  .component('singleServiceActionsMenu', {
    bindings: {
      onOpen: '=',
      serviceStatus: '<',
      service: '<',
      onSendServiceTextMessage: '&',
      onCreateDelivery: '&',
      onDeclineService: '&',
      onEditService: '&'
    },
    template: require('./single-service-actions-menu.html').default,
    controller: singleServiceActionsMenuCtrl
  });
